import { ECountry } from './countries';

export const COUNTRY_PREFIXES: Record<ECountry, string> = {
  [ECountry.AF]: '+93',
  [ECountry.AL]: '+355',
  [ECountry.DZ]: '+213',
  [ECountry.AD]: '+376',
  [ECountry.AO]: '+244',
  [ECountry.AG]: '+1',
  [ECountry.AR]: '+54',
  [ECountry.AM]: '+374',
  [ECountry.AU]: '+61',
  [ECountry.AT]: '+43',
  [ECountry.AZ]: '+994',
  [ECountry.BS]: '+1',
  [ECountry.BH]: '+973',
  [ECountry.BD]: '+880',
  [ECountry.BB]: '+1',
  [ECountry.BY]: '+375',
  [ECountry.BE]: '+32',
  [ECountry.BZ]: '+501',
  [ECountry.BJ]: '+229',
  [ECountry.BT]: '+975',
  [ECountry.BO]: '+591',
  [ECountry.BA]: '+387',
  [ECountry.BW]: '+267',
  [ECountry.BR]: '+55',
  [ECountry.BN]: '+673',
  [ECountry.BG]: '+359',
  [ECountry.BF]: '+226',
  [ECountry.BI]: '+257',
  [ECountry.CV]: '+238',
  [ECountry.KH]: '+855',
  [ECountry.CM]: '+237',
  [ECountry.CA]: '+1',
  [ECountry.CF]: '+236',
  [ECountry.TD]: '+235',
  [ECountry.CL]: '+56',
  [ECountry.CN]: '+86',
  [ECountry.CO]: '+57',
  [ECountry.KM]: '+269',
  [ECountry.CG]: '+242',
  [ECountry.CD]: '+243',
  [ECountry.CR]: '+506',
  [ECountry.CI]: '+225',
  [ECountry.HR]: '+385',
  [ECountry.CU]: '+53',
  [ECountry.CY]: '+357',
  [ECountry.CZ]: '+420',
  [ECountry.DK]: '+45',
  [ECountry.DJ]: '+253',
  [ECountry.DM]: '+1',
  [ECountry.DO]: '+1',
  [ECountry.EC]: '+593',
  [ECountry.EG]: '+20',
  [ECountry.SV]: '+503',
  [ECountry.GQ]: '+240',
  [ECountry.ER]: '+291',
  [ECountry.EE]: '+372',
  [ECountry.SZ]: '+268',
  [ECountry.ET]: '+251',
  [ECountry.FJ]: '+679',
  [ECountry.FI]: '+358',
  [ECountry.FR]: '+33',
  [ECountry.GA]: '+241',
  [ECountry.GM]: '+220',
  [ECountry.GE]: '+995',
  [ECountry.DE]: '+49',
  [ECountry.GH]: '+233',
  [ECountry.GR]: '+30',
  [ECountry.GD]: '+1',
  [ECountry.GT]: '+502',
  [ECountry.GN]: '+224',
  [ECountry.GW]: '+245',
  [ECountry.GY]: '+592',
  [ECountry.HT]: '+509',
  [ECountry.HN]: '+504',
  [ECountry.HU]: '+36',
  [ECountry.IS]: '+354',
  [ECountry.IN]: '+91',
  [ECountry.ID]: '+62',
  [ECountry.IR]: '+98',
  [ECountry.IQ]: '+964',
  [ECountry.IE]: '+353',
  [ECountry.IL]: '+972',
  [ECountry.ITA]: '+39',
  [ECountry.JM]: '+1',
  [ECountry.JP]: '+81',
  [ECountry.JO]: '+962',
  [ECountry.KZ]: '+7',
  [ECountry.KE]: '+254',
  [ECountry.KI]: '+686',
  [ECountry.KP]: '+850',
  [ECountry.KR]: '+82',
  [ECountry.KW]: '+965',
  [ECountry.KG]: '+996',
  [ECountry.LA]: '+856',
  [ECountry.LV]: '+371',
  [ECountry.LB]: '+961',
  [ECountry.LS]: '+266',
  [ECountry.LR]: '+231',
  [ECountry.LY]: '+218',
  [ECountry.LI]: '+423',
  [ECountry.LT]: '+370',
  [ECountry.LU]: '+352',
  [ECountry.MG]: '+261',
  [ECountry.MW]: '+265',
  [ECountry.MY]: '+60',
  [ECountry.MV]: '+960',
  [ECountry.ML]: '+223',
  [ECountry.MT]: '+356',
  [ECountry.MH]: '+692',
  [ECountry.MR]: '+222',
  [ECountry.MU]: '+230',
  [ECountry.MX]: '+52',
  [ECountry.FM]: '+691',
  [ECountry.MD]: '+373',
  [ECountry.MC]: '+377',
  [ECountry.MN]: '+976',
  [ECountry.ME]: '+382',
  [ECountry.MA]: '+212',
  [ECountry.MZ]: '+258',
  [ECountry.MM]: '+95',
  [ECountry.NA]: '+264',
  [ECountry.NR]: '+674',
  [ECountry.NP]: '+977',
  [ECountry.NL]: '+31',
  [ECountry.NZ]: '+64',
  [ECountry.NI]: '+505',
  [ECountry.NE]: '+227',
  [ECountry.NG]: '+234',
  [ECountry.MK]: '+389',
  [ECountry.NO]: '+47',
  [ECountry.OM]: '+968',
  [ECountry.PK]: '+92',
  [ECountry.PW]: '+680',
  [ECountry.PS]: '+970',
  [ECountry.PA]: '+507',
  [ECountry.PG]: '+675',
  [ECountry.PY]: '+595',
  [ECountry.PE]: '+51',
  [ECountry.PH]: '+63',
  [ECountry.PL]: '+48',
  [ECountry.PT]: '+351',
  [ECountry.PR]: '+1',
  [ECountry.QA]: '+974',
  [ECountry.RO]: '+40',
  [ECountry.RU]: '+7',
  [ECountry.RW]: '+250',
  [ECountry.KN]: '+1',
  [ECountry.LC]: '+1',
  [ECountry.VC]: '+1',
  [ECountry.WS]: '+685',
  [ECountry.SM]: '+378',
  [ECountry.ST]: '+239',
  [ECountry.SA]: '+966',
  [ECountry.SN]: '+221',
  [ECountry.RS]: '+381',
  [ECountry.SC]: '+248',
  [ECountry.SL]: '+232',
  [ECountry.SG]: '+65',
  [ECountry.SK]: '+421',
  [ECountry.SI]: '+386',
  [ECountry.SB]: '+677',
  [ECountry.SO]: '+252',
  [ECountry.ZA]: '+27',
  [ECountry.SS]: '+211',
  [ECountry.ES]: '+34',
  [ECountry.LK]: '+94',
  [ECountry.SD]: '+249',
  [ECountry.SR]: '+597',
  [ECountry.SE]: '+46',
  [ECountry.CH]: '+41',
  [ECountry.SY]: '+963',
  [ECountry.TW]: '+886',
  [ECountry.TJ]: '+992',
  [ECountry.TZ]: '+255',
  [ECountry.TH]: '+66',
  [ECountry.TL]: '+670',
  [ECountry.TG]: '+228',
  [ECountry.TO]: '+676',
  [ECountry.TT]: '+1',
  [ECountry.TN]: '+216',
  [ECountry.TR]: '+90',
  [ECountry.TM]: '+993',
  [ECountry.TV]: '+688',
  [ECountry.UG]: '+256',
  [ECountry.UA]: '+380',
  [ECountry.AE]: '+971',
  [ECountry.GB]: '+44',
  [ECountry.US]: '+1',
  [ECountry.UY]: '+598',
  [ECountry.UZ]: '+998',
  [ECountry.VU]: '+678',
  [ECountry.VA]: '+39',
  [ECountry.VE]: '+58',
  [ECountry.VN]: '+84',
  [ECountry.YE]: '+967',
  [ECountry.ZM]: '+260',
  [ECountry.ZW]: '+263',
  [ECountry.GF]: '+594'
};

export const getCountryPrefix = (country: ECountry): string => {
  return COUNTRY_PREFIXES[country] || '+34';
};
